module.exports = __webpack_public_path__ + "static/media/redo.37d4f697.svg";